import { InfoCircleOutlined, LoadingOutlined, SyncOutlined, UploadOutlined } from "@ant-design/icons";
import { Pagination, Select, Spin, Tag, Tooltip } from "antd";
import { Dropdown, Menu } from "antd";
import { notification } from "antd";
import ManageAccess from "components/common/ManageAccess/manageAccess";
import UploadModal from "components/common/UploadModal/uploadModal";
import { AudioIcon, Close, FilterInput } from "components/icons";
import { ENTITY_TYPE, searchParamsFilters } from "constants/phase";
import { get } from "lodash";
import { debounce } from "lodash";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useOutletContext, useParams, useSearchParams } from "react-router-dom";

import Image from "../../../components/common/Image/component";
import ConfirmationDialog from "../../../components/common/Modals/component";
import PreviewDialog from "../../../components/common/Modals/PreviewDialog";
import SendToWorkSpace from "../../../components/common/SendToWorkSpace/SendToWorkSpace";
import { DotsIcon } from "../../../components/icons";
import amplitude from "../../../externals/amplitude";
import Filter from "./filter";

const tabs = {
  GRAPHIC: "graphic",
  OVERLAY: "overlay",
  BUMPER: "bumper",
  AUDIO: "audio",
};
const header = "Delete";
const content = "Are you sure you want to delete?";
const MediaContent = (props) => {
  const [activePage, setActivePage] = useState(1);
  const firstRef = useRef(true);
  const secondRef = useRef(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const updatedSearchParams = new URLSearchParams(searchParams);
  const [filterCount, setFilterCount] = useState(0);
  const [mediaData, setMediaData] = useState([]);
  const [selectedMediaItem, setSelectedMediaItem] = useState({});
  const [totalLength, setTotalLength] = useState(15);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [delOpen, setDelOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [activeTab, setActiveTab] = useState(tabs.BUMPER);
  const [filterOpen, setFilterOpen] = useState(false);
  const [limit, setLimit] = useState(15);
  const [openDropZone, setOpenDropZone] = useState(false);
  const [uploadFileData, setUploadFileData] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState([]);
  const [folderNames, setFolderNames] = useState([]);
  const [folder, setFolder] = useState([]);
  const [uploadFilesLength, setUploadFilesLength] = useState(0);
  const [workspaceFolders, setWorkspaceFolders] = useState([]);
  const [folders, setFolders] = useState([]);
  const [uploadLoader, setUploadLoader] = useState(false);
  const [acceptType, setAcceptType] = useState([]);
  const [fileType, setFileType] = useState([]);
  const antIcon = <LoadingOutlined style={{ fontSize: 24, align: "center" }} spin />;
  const [filters, setFilters] = useState(searchParamsFilters);
  const [finalFilters, setFinalFilters] = useState(filters || searchParamsFilters);
  const [searchText, setSearchText] = useState(filters.bumperSearch || "");
  const { id: entityId } = useParams();
  const { Option } = Select;
  const [singleFolder, setSingleFolder] = useState("");
  const [openSendToWorkspaceModal, setOpenSendToWorkspaceModal] = useState(false);

  const {
    showSlate,
    getImages,
    getAudio,
    isValidStream,
    getTimeLineDuration,
    entityConfig,
    resyncIllustoResource,
    addSlate,
    addImages,
    addAudioToFolder,
  } = props;
  const { entityType } = useOutletContext();
  useEffect(() => {
    let filters = JSON.parse(searchParams.get("filters")) || searchParamsFilters;
    setFilters(filters);
    setFilterCount(filterCount + 1);
  }, [searchParams]);

  const getGraphics = async () => {
    setLoader(true);
    const { value } = await getImages({
      folderId: singleFolder,
      entityId,
      sortBy: filters?.graphicsort,
      search: filters?.graphicSearch ? filters?.graphicSearch : undefined,
      format: filters?.graphicformats.length > 0 ? filters?.graphicformats : undefined,
    });
    if (value.success) {
      setTotalLength(value?.totalLength);
      setMediaData(value.imageData || []);
    } else {
      notification["error"]({ message: value.message });
    }
    setLoader(false);
  };
  const getCustomField = async () => {
    const { getCustomFields } = props;
    const { value } = await getCustomFields({ entityId: entityId });
    if (value.success) {
      setFolder(value?.setting?.folder_name);
      let folderName = [{ name: "All", _id: 1 }, ...(value?.setting?.folder_name || [])];
      setFolderNames(folderName);
    }
  };

  useEffect(() => {
    getCustomField();
  }, [entityId]);

  const getAudios = async () => {
    const { getAudio } = props;
    setLoader(true);
    const { value } = await getAudio({
      folderId: "",
      search: filters?.audioSearch,
      sortBy: filters?.audiosort,
      format: filters?.audioformats.length > 0 ? filters?.audioformats : undefined,
      entityId,
    });
    if (value.success) {
      setMediaData(value.data || []);
      setLoader(false);
    } else {
      notification["error"]({ message: value.message });
    }
  };

  const previewModal = (slate) => {
    setPreviewOpen(true);
    setSelectedMediaItem(slate);
    amplitude.logEvent("banner_preview_triggered", {
      page: "media-content",
    });
  };

  const getBumpers = async (next) => {
    setLoader(true);
    const { value } = await showSlate({
      entityId,
      limit,
      pageNo: next ? 1 : activePage,
      folderId: singleFolder,
      sortBy: filters?.bumpersort,
      search: filters?.bumperSearch ? filters?.bumperSearch : undefined,
      aspectRatio: filters?.bumperratios.length > 0 ? filters?.bumperratios : undefined,
    });
    if (value.success) {
      setTotalLength(value?.totalLength);
      setMediaData(value?.data || []);
    } else {
      notification["error"]({ message: value.message });
    }
    setLoader(false);
  };
  const getOverlays = async (next) => {
    setLoader(true);
    const { value } = await showSlate({
      entityId: entityId,
      limit,
      pageNo: next ? 1 : activePage,
      type: "mov",
      sortBy: filters?.overlaysort,
      search: filters?.overlaySearch ? filters?.overlaySearch : undefined,
      aspectRatio: filters?.overlayratios.length > 0 ? filters?.overlayratios : undefined,
      folderId: singleFolder,
    });
    if (value.success) {
      setTotalLength(value?.totalLength);
      setMediaData(value?.data || []);
    } else {
      notification["error"]({ message: value.message });
    }
    setLoader(false);
  };
  const deleteFunction = (slate) => {
    setSelectedMediaItem(slate);
    setDelOpen(true);
    amplitude.logEvent("delete_modal_triggered", {
      page: "media-content",
    });
  };

  const filterModal = () => {
    setFilterOpen(true);
  };

  useEffect(() => {
    if (filterCount > 0) {
      setActivePage(1);
      if (activeTab === tabs.BUMPER) {
        getBumpers();
      } else if (activeTab === tabs.GRAPHIC) {
        getGraphics();
      } else if (activeTab === tabs.OVERLAY) {
        getOverlays();
      } else {
        getAudios();
      }
    }
  }, [filterCount]);

  useEffect(() => {
    if (activeTab === tabs.BUMPER) {
      getBumpers();
    } else if (activeTab === tabs.GRAPHIC) {
      getGraphics();
    } else if (activeTab === tabs.OVERLAY) {
      getOverlays();
    } else if (activeTab === tabs.AUDIO) {
      getAudios();
    }
  }, [activePage, singleFolder]);
  // useEffect(() => {
  //   getBumpers();
  // }, [singleFolder]);
  useEffect(() => {
    setActivePage(1);
    if (activeTab === tabs.BUMPER) {
      getBumpers();
      setSearchText(filters?.bumperSearch);
      setAcceptType("video/*");
      setFileType(["mp4", "octet-stream"]);
    } else if (activeTab === tabs.GRAPHIC) {
      getGraphics();
      setSearchText(filters?.graphicSearch);
      setAcceptType("image/*");
      setFileType(["jpg", "jpeg", "png", "octet-stream"]);
    } else if (activeTab === tabs.OVERLAY) {
      getOverlays();
      setSearchText(filters?.overlaySearch);
      setAcceptType("");
      setFileType(["quicktime", "mov"]);
    } else {
      getAudios();
      setSearchText(filters?.audioSearch);
      setAcceptType("audio/*");
      setFileType(["mp3", "mpeg"]);
    }
  }, [activeTab]);

  const onClose = () => {
    setDelOpen(false);
  };

  const debouncedSearchChangeRef = useRef(
    debounce((value) => {
      if (value) {
        amplitude.logEvent("entity_searched", {
          text: value,
          page: "media-content",
        });
      }
    }, 800),
  );

  const handleSearchChange = (e) => {
    debouncedSearchChangeRef.current(e.target.value);
    setSearchText(e.target.value);
    firstRef.current = false;
  };

  const handlePageChange = (pageNo) => {
    setActivePage(pageNo);
  };

  useEffect(() => {
    if (firstRef.current) {
      firstRef.current = false;
    } else {
      const searchKey = activeTab + "Search";
      const timer = setTimeout(() => {
        updatedSearchParams.set("filters", JSON.stringify({ ...filters, [searchKey]: searchText }));
        setSearchParams(updatedSearchParams);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [searchText]);

  const isAudioFun = (fileData) => {
    return new Promise((resolve) => {
      isValidStream({ url: fileData.uploadFileUrl }).then((response) => {
        if (response?.value?.data?.result?.audio?.length) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  };

  const getDuration = async (fileData) => {
    //Sound duration function
    return new Promise(async (resolve) => {
      const data = await getTimeLineDuration({ url: fileData.uploadFileUrl });
      if (data?.value?.status) {
        resolve(data?.value?.duration);
      }
    });
  };
  const updateFilterData = (index) => {
    let filterKey = "";
    switch (activeTab) {
      case tabs.BUMPER:
        filters.bumperratios.splice(index, 1);
        filterKey = "bumperratios";
        break;
      case tabs.GRAPHIC:
        filters.graphicformats.splice(index, 1);
        filterKey = "graphicformats";
        break;
      case tabs.OVERLAY:
        filters.overlayratios.splice(index, 1);
        filterKey = "overlayratios";
        break;
      case tabs.AUDIO:
        filters.audioformats.splice(index, 1);
        filterKey = "audioformats";
        break;
      default:
        break;
    }

    updatedSearchParams.set("filters", JSON.stringify({ ...filters, [filterKey]: filters[filterKey] }));
    setSearchParams(updatedSearchParams);
    setFinalFilters({ ...filters, [filterKey]: filters[filterKey] });
    setActivePage(1);
  };

  const onSubmit = async () => {
    try {
      const { addSlate, addImages, addAudioToFolder } = props;
      setUploadLoader(true);
      setOpenDropZone(false);

      if (uploadFileData && uploadFileData.length !== 0) {
        await Promise.all(
          uploadFileData.map(async (item) => {
            if (activeTab === tabs.BUMPER || activeTab === tabs.OVERLAY) {
              item.isAudio = await isAudioFun(item);
            } else if (activeTab === tabs.AUDIO) {
              item.uploadDuration = await getDuration(item);
            }
            return item;
          }),
        );

        uploadFileData.forEach(async (item) => {
          if (activeTab === tabs.BUMPER) {
            if (item.fileType !== "video") {
              notification["warning"]({ message: `Wrong file ${item.uploadUrlTitle} uploaded!` });
              setUploadLoader(false);
            } else if (!item.isAudio) {
              notification["warning"]({ message: `Audio is not available in ${item.uploadUrlTitle} bumper` });
              setUploadLoader(false);
            } else {
              const urlData = await getTimeLineDuration({ url: item.uploadFileUrl });
              const selectedFoldersIds = workspaceFolders.filter(({ selectedFolderId }) => selectedFolderId);
              selectedFoldersIds.forEach((folder) => {
                addSlate({
                  entityId: folder.selectedWorkspaceId,
                  folderId: [folder.selectedFolderId],
                  url: item.uploadFileUrl,
                  title: item.uploadUrlTitle,
                  type: item.fileType,
                  duration: urlData?.value?.duration,
                });
              });
              addSlate({
                entityId,
                url: item.uploadFileUrl,
                title: item.uploadUrlTitle,
                type: item.fileType,
                duration: urlData?.value?.duration,
                folderId: selectedFolder,
              })
                .then((response) => {
                  if (response.value.success) {
                    notification["success"]({ message: response.value.message });
                    getBumpers();
                  }
                })
                .catch((error) => notification["error"]({ message: error.message }));
            }
          } else if (activeTab === tabs.AUDIO) {
            if (item.fileType !== tabs.AUDIO) {
              notification["warning"]({ message: `Wrong file ${item.uploadUrlTitle} uploaded!` });
              setUploadLoader(false);
            } else {
              const selectedFoldersIds = workspaceFolders.filter(({ selectedFolderId }) => selectedFolderId);
              selectedFoldersIds.forEach((folder) => {
                addAudioToFolder({
                  entityId: folder.selectedWorkspaceId,
                  folderId: [folder.selectedFolderId],
                  url: item.uploadFileUrl,
                  title: item.uploadUrlTitle,
                  type: item.fileType,
                  duration: item.uploadDuration,
                });
              });
              addAudioToFolder({
                entityId,
                url: item.uploadFileUrl,
                title: item.uploadUrlTitle,
                type: item.fileType,
                duration: item.uploadDuration,
                folderId: selectedFolder,
              })
                .then((response) => {
                  if (response.value.status) {
                    notification["success"]({ message: response.value.message });
                    getAudios();
                  }
                })
                .catch((error) => notification["error"]({ message: error.message }));
            }
          } else if (activeTab === tabs.GRAPHIC) {
            const selectedFoldersIds = workspaceFolders.filter(({ selectedFolderId }) => selectedFolderId);
            selectedFoldersIds.forEach((folder) => {
              addImages({
                imgUrl: item.uploadFileUrl,
                userId: localStorage.getItem("__uid"),
                entityId: folder.selectedWorkspaceId,
                folderId: [folder.selectedFolderId],
                imgName: Math.random().toString(36).slice(2),
                title: item.uploadUrlTitle,
              });
            });
            addImages({
              imgUrl: item.uploadFileUrl,
              userId: localStorage.getItem("__uid"),
              entityId,
              imgName: Math.random().toString(36).slice(2),
              folderId: selectedFolder,
              title: item.uploadUrlTitle,
            })
              .then((response) => {
                if (response.value.status) {
                  notification["success"]({ message: response.value.message });
                  getGraphics();
                }
              })
              .catch((error) => notification["error"]({ message: error.message }));
          } else {
            const urlData = await getTimeLineDuration({ url: item.uploadFileUrl });
            const selectedFoldersIds = workspaceFolders.filter(({ selectedFolderId }) => selectedFolderId);
            selectedFoldersIds.forEach((folder) => {
              addSlate({
                entityId: folder.selectedWorkspaceId,
                folderId: [folder.selectedFolderId],
                url: item.uploadFileUrl,
                title: item.uploadUrlTitle,
                type: "mov",
                duration: urlData?.value?.duration,
              });
            });
            addSlate({
              entityId,
              url: item.uploadFileUrl,
              title: item.uploadUrlTitle,
              type: "mov",
              duration: urlData?.value?.duration,
              folderId: selectedFolder,
            })
              .then((response) => {
                if (response.value.success) {
                  notification["success"]({ message: "Overlay added successfully!" });
                  getOverlays();
                } else {
                }
                setFilterCount(filterCount + 1);
                setUploadLoader(false);
                setSelectedFolder([]);
                setUploadFileData([]);
              })
              .catch((error) => notification["success"]({ message: error.message }));
          }
        });
      }
    } catch (error) {
      notification["error"]({ message: error.message });
    } finally {
      setUploadLoader(false);
      setSelectedFolder([]);
      setUploadFileData([]);
    }
  };

  const openDropZoneModal = () => {
    setOpenDropZone(true);
    amplitude.logEvent("upload_modal_triggered", {
      page: "media-content",
    });
  };

  const onChange = async (e) => {
    setUploadFileData([...uploadFileData, ...e]);
  };

  const onDelete = async () => {
    secondRef.current = true;
    let deleteFunction;
    let successMessage = `${activeTab.charAt(0).toUpperCase()}${activeTab.slice(1)} deleted successfully!`;
    if (activeTab === tabs.BUMPER) {
      deleteFunction = props.deleteSlate;
    } else if (activeTab === tabs.OVERLAY) {
      deleteFunction = props.deleteSlate;
    } else if (activeTab === tabs.AUDIO) {
      deleteFunction = props.deleteAudio;
    } else if (activeTab === tabs.GRAPHIC) {
      deleteFunction = props.deleteImages;
    }
    if (!deleteFunction) {
      console.error("Delete function not defined for active tab:", activeTab);
      return;
    }
    try {
      const key = activeTab === tabs.GRAPHIC ? "imgId" : "_id";
      const payload = activeTab !== tabs.AUDIO ? { [key]: selectedMediaItem._id } : selectedMediaItem._id;
      const { value } = await deleteFunction(payload);
      if (value.success) {
        notification["success"]({ message: successMessage });
        if (activeTab === tabs.AUDIO) {
          getAudios();
          setLoader(false);
        } else {
          setActivePage(1);
          if (activeTab === tabs.BUMPER) {
            getBumpers();
          } else if (activeTab === tabs.OVERLAY) {
            getOverlays();
          } else if (activeTab === tabs.GRAPHIC) {
            getGraphics();
          }
          setTotalLength(totalLength - 1);
        }
        onClose();
      }
    } catch (error) {
      console.error("Error occurred during deletion:", error);
    }
  };

  const resyncResource = async () => {
    const { value } = await resyncIllustoResource({
      entityId,
    });
    notification["success"]({ message: "Syncing process initiated" });
  };
  const onChangeFolder = (e) => {
    //Select folder to add bumper
    setActivePage(1);
    if (e === "All") {
      setSingleFolder("");
    } else {
      for (var i = 0; i < folderNames.length; i++) {
        if (folderNames[i]?.name === e) {
          setSingleFolder(folderNames[i]?._id);
        }
      }
    }

    amplitude.logEvent("bumper_folder_selected", {
      name: e,
      page: "clip-editor",
    });
  };

  const sendToWorkspace = (slate) => {
    setSelectedMediaItem(slate);
    setOpenSendToWorkspaceModal(true);
  };

  const handleSendToWorkspaceSubmit = async (values) => {
    const data = await Promise.all(
      values.folders.map(async (folder) => {
        if (activeTab === tabs.GRAPHIC) {
          return addImages({
            imgUrl: selectedMediaItem.imgUrl,
            entityId: folder.selectedWorkspaceId,
            folderId: [folder.selectedFolderId],
            imgName: Math.random().toString(36).slice(2),
            title: selectedMediaItem.title,
          });
        } else if (activeTab === tabs.OVERLAY) {
          return addSlate({
            entityId: folder.selectedWorkspaceId,
            folderId: [folder.selectedFolderId],
            url: selectedMediaItem.url,
            title: selectedMediaItem.title,
            type: "mov",
            duration: selectedMediaItem.duration,
          });
        } else if (activeTab === tabs.AUDIO) {
          return addAudioToFolder({
            entityId: folder.selectedWorkspaceId,
            folderId: [folder.selectedFolderId],
            url: selectedMediaItem.audioUrl || selectedMediaItem.url,
            title: selectedMediaItem.title,
            type: "audio",
            duration: selectedMediaItem.duration,
          });
        } else if (activeTab === tabs.BUMPER) {
          return addSlate({
            entityId: folder.selectedWorkspaceId,
            folderId: [folder.selectedFolderId],
            url: selectedMediaItem.url,
            title: selectedMediaItem.title,
            type: selectedMediaItem.type,
            duration: selectedMediaItem.duration,
          });
        } else {
          return;
        }
      }),
    );

    if (data && data.length && (data[0]?.value?.success || data[0]?.value?.status)) {
      notification["success"]({ message: "Send to workspace successfully." });
      activePage === 1 ? showSlate() : setActivePage(1);
    } else {
      notification["error"]({ message: data[0]?.value?.message || "Something went wrong" });
    }
    setOpenSendToWorkspaceModal(false);
    setSelectedFolder([]);
    setUploadFileData([]);
  };
  return (
    <>
      {" "}
      <SendToWorkSpace
        openSendToWorkspaceModal={openSendToWorkspaceModal}
        setOpenSendToWorkspaceModal={setOpenSendToWorkspaceModal}
        handleSubmit={handleSendToWorkspaceSubmit}
        setWorkspaceFolders={setWorkspaceFolders}
        workspaceFolders={workspaceFolders}
      />
      <UploadModal
        openDropZone={openDropZone}
        setOpenDropZone={setOpenDropZone}
        onChange={onChange}
        selectedFolder={selectedFolder}
        setSelectedFolder={setSelectedFolder}
        setWorkspaceFolders={setWorkspaceFolders}
        workspaceFolders={workspaceFolders}
        folder={folder}
        onSubmit={onSubmit}
        uploadLoader={uploadLoader}
        setUploadFilesLength={setUploadFilesLength}
        uploadFilesLength={uploadFilesLength}
        uploadFileData={uploadFileData}
        setUploadFileData={setUploadFileData}
        setUploadLoader={setUploadLoader}
        acceptType={acceptType}
        fileType={fileType}
        component={
          activeTab === tabs.GRAPHIC
            ? "logo"
            : activeTab === tabs.AUDIO
              ? "sound"
              : activeTab === tabs.BUMPER
                ? tabs.BUMPER
                : ""
        }
        {...props}
      />
      <Filter
        loader={loader}
        activeTab={activeTab}
        setFilters={setFilters}
        filterOpen={filterOpen}
        setFilterOpen={setFilterOpen}
        filters={filters}
        searchParams={searchParams}
        updatedSearchParams={updatedSearchParams}
        setSearchParams={setSearchParams}
        finalFilters={finalFilters}
        setFinalFilters={setFinalFilters}
      />
      {activeTab === tabs.GRAPHIC ? (
        <PreviewDialog
          imageUrl={selectedMediaItem?.imgUrl}
          clipTitle={selectedMediaItem?.title}
          modalIsOpen={previewOpen}
          setIsOpen={setPreviewOpen}
        />
      ) : (
        <PreviewDialog
          slateUrl={selectedMediaItem?.url}
          clipTitle={selectedMediaItem?.title}
          modalIsOpen={previewOpen}
          setIsOpen={setPreviewOpen}
        />
      )}
      <ConfirmationDialog
        modalIsOpen={delOpen}
        deleteComanModel={onDelete}
        onClose={onClose}
        content={content}
        id={selectedMediaItem._id}
        loder={loader}
        header={header}
        setDeleteModalOpen={setDelOpen}
      />
      <div className="right-container--op">
        <div className="title-block--op">
          <div>
            <h4>Media Contents</h4>
          </div>
          {entityConfig?.permissions?.advanceEditor ? (
            <div className="gap-2 d-flex align-items-center me-2">
              <InfoCircleOutlined />
              Sync your media assets with your Illusto account.
              <button
                className="btn btn-primary gap-2"
                disabled={!entityConfig?.illusto?.accountSecret}
                onClick={() => resyncResource()}
              >
                <SyncOutlined />
                Sync
              </button>
            </div>
          ) : null}
        </div>
        <div className="publish-tab-conatiner">
          <button
            className={activeTab === tabs.BUMPER ? "active" : ""}
            onClick={() => {
              setActiveTab(tabs.BUMPER);
            }}
          >
            Bumpers
          </button>
          <button
            className={activeTab === tabs.GRAPHIC ? "active" : ""}
            onClick={() => {
              setActiveTab(tabs.GRAPHIC);
            }}
          >
            Graphics
          </button>
          <button
            className={activeTab === tabs.OVERLAY ? "active" : ""}
            onClick={() => {
              setActiveTab(tabs.OVERLAY);
            }}
          >
            Overlays
          </button>
          <button
            className={activeTab === tabs.AUDIO ? "active" : ""}
            onClick={() => {
              setActiveTab(tabs.AUDIO);
            }}
          >
            Audios
          </button>
        </div>
        <div className="title-block--op">
          <div></div>
          <div className="d-flex gap-3 flex-grow-1 justify-content-end">
            <div className="flex-grow-1">
              <Select
                className="custom-ant-select"
                name="folder"
                showSearch
                // component={Select}
                onChange={(e) => onChangeFolder(e)}
                dropdownStyle={{ zIndex: 99999999 }}
                placeholder="Select Folder"
                defaultValue={"All"}
              >
                {folderNames?.length > 0 &&
                  folderNames?.map((data, index) => {
                    return (
                      <>
                        <Option key={index} value={data.name}>
                          {data.name}
                        </Option>
                      </>
                    );
                  })}
              </Select>
            </div>

            <div className="right-filter-search--op">
              <input
                type="text"
                onChange={handleSearchChange}
                placeholder="Search"
                className="form-control filters-search-control"
                value={searchText}
              />
              <button className="filter-input--search-filter" onClick={filterModal}>
                <FilterInput />
              </button>
            </div>
            <button className="btn btn-primary gap-2" onClick={() => openDropZoneModal()}>
              <UploadOutlined />
              Upload {activeTab}
            </button>
          </div>
        </div>
        <div className="d-flex justify-content-end mb-3">
          <ul className="filter-tags-list">
            {activeTab === tabs.BUMPER &&
              filters?.bumperratios?.map((data, index) => (
                <li className="text-capitalize">
                  {data}
                  <button
                    className="btn btn-filter-remove"
                    onClick={() => {
                      updateFilterData(index);
                    }}
                  >
                    <Close />
                  </button>
                </li>
              ))}

            {activeTab === tabs.GRAPHIC &&
              filters?.graphicformats?.map((data, index) => (
                <li className="text-capitalize">
                  {data}
                  <button
                    className="btn btn-filter-remove"
                    onClick={() => {
                      updateFilterData(index);
                    }}
                  >
                    <Close />
                  </button>
                </li>
              ))}

            {activeTab === tabs.OVERLAY &&
              filters?.overlayratios?.map((data, index) => (
                <li className="text-capitalize">
                  {data}
                  <button
                    className="btn btn-filter-remove"
                    onClick={() => {
                      updateFilterData(index);
                    }}
                  >
                    <Close />
                  </button>
                </li>
              ))}

            {activeTab === tabs.AUDIO &&
              filters?.audioformats?.map((data, index) => (
                <li className="text-capitalize">
                  {data}
                  <button
                    className="btn btn-filter-remove"
                    onClick={() => {
                      updateFilterData(index);
                    }}
                  >
                    <Close />
                  </button>
                </li>
              ))}
          </ul>
        </div>
        <div className="bumper-elements">
          {loader ? (
            <Spin indicator={antIcon} />
          ) : activeTab !== "audio" ? (
            <div className="vv-grid clip-grid-view" grid-size="5">
              {mediaData &&
                mediaData.slice(0).map((slate) => {
                  return (
                    <div className="vv-grid-item" key={slate._id}>
                      <div className="bumper-elements-card">
                        <div className="bumper-elements-thumb" onClick={() => previewModal(slate)}>
                          {activeTab !== tabs.GRAPHIC ? (
                            <video
                              src={slate.url}
                              onMouseOver={(e) => e.target.play()}
                              onMouseOut={(e) => e.target.pause()}
                            />
                          ) : (
                            <Image
                              src={slate.imgUrl}
                              // value={imgValue}
                              alt=""
                              // onChange={(e) => setImgValue(e.target.value)}
                            />
                          )}
                          <div className="vv-video-bottom-info pt-0">
                            <div className="vv-video-bottom-left-info"></div>
                            <div className="vv-video-bottom-right-info text-end">
                              {activeTab !== tabs.GRAPHIC && (
                                <div className="vv-video-duration">
                                  {slate.duration ? moment.utc(slate.duration * 1000).format("mm:ss") : "00:00"}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="title-name-type">
                          <div className="bumper-name" title={slate?.title ? slate?.title : ""}>
                            {slate?.title.length > 13 ? slate?.title.substring(0, 13) + "..." : slate?.title}
                          </div>
                          <ManageAccess value={slate?.format}>
                            <div className="vv-video-clip-tags blue-tags-group">
                              <Tag>
                                <strong>{slate?.format ? slate?.format : ""}</strong>
                              </Tag>
                            </div>
                          </ManageAccess>
                          <span className="duration-block-bottom">
                            {moment(get(slate, "createdAt", "")).format("ll")},{" "}
                            {moment(slate.createdAt).format("h:mm A")}
                          </span>
                        </div>
                      </div>
                      <div className="vv-video-top-info">
                        <div className="card-video-ar red ratio-card-block">{slate?.aspectRatio}</div>
                        <div className="action-overlay">
                          <Dropdown
                            overlay={
                              <Menu
                                items={[
                                  entityType !== ENTITY_TYPE.WORKSPACES
                                    ? {
                                        label: (
                                          <button className="btn" onClick={() => sendToWorkspace(slate)}>
                                            Send to workspace
                                          </button>
                                        ),
                                        key: "sent_to_workspace",
                                      }
                                    : null,
                                  activeTab !== tabs.OVERLAY
                                    ? {
                                        label: (
                                          <button className="btn" onClick={() => previewModal(slate)}>
                                            Preview
                                          </button>
                                        ),
                                        key: "0",
                                      }
                                    : null,
                                  {
                                    label: (
                                      <button className="btn" onClick={() => deleteFunction(slate)}>
                                        Delete
                                      </button>
                                    ),
                                    key: "1",
                                  },
                                ]}
                              />
                            }
                            trigger={["click"]}
                            className="custom-ant-more-dropdown"
                            overlayClassName="tableActionBlock"
                          >
                            <a onClick={(e) => e.preventDefault()}>
                              <DotsIcon />
                            </a>
                          </Dropdown>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          ) : (
            <>
              <div className="audio-sound">
                <div className="audio-sound-list tab-audio-list-items">
                  {mediaData &&
                    mediaData.slice(0).map((item) => (
                      <div key={item._id} className="audio-sound-list-item">
                        <div className="audio-sound-card">
                          <div className="audio-blocktitle-section">
                            <div className="audio-sound-icon">
                              <AudioIcon />
                            </div>
                            <div className="audio-sound-content">
                              <h5 className="audio-sound-title">
                                <Tooltip title={item.title}>
                                  {item.title
                                    ? item.title.substring(0, 30) + (item.title.length > 30 ? "..." : "")
                                    : ""}
                                </Tooltip>
                              </h5>
                              <div className="audio-sound-duration">
                                {moment.utc((item?.duration || 0) * 1000).format("mm:ss")}
                              </div>
                            </div>
                          </div>
                          <div className="audio-player-block-v2">
                            <audio id="audio-player" controls src={item.audioUrl ? item.audioUrl : null} />
                          </div>
                          <div className="action-overlay">
                            <Dropdown
                              overlay={
                                <Menu
                                  items={[
                                    entityType !== ENTITY_TYPE.WORKSPACES && {
                                      label: (
                                        <button className="btn" onClick={() => sendToWorkspace(item)}>
                                          Send to workspace
                                        </button>
                                      ),
                                      key: "sent_to_workspace",
                                    },
                                    {
                                      label: (
                                        <button className="btn" onClick={() => deleteFunction(item)}>
                                          Delete
                                        </button>
                                      ),
                                      key: "0",
                                    },
                                  ]}
                                />
                              }
                              trigger={["click"]}
                              className="custom-ant-more-dropdown"
                              overlayClassName="tableActionBlock"
                            >
                              <a onClick={(e) => e.preventDefault()}>
                                <DotsIcon />
                              </a>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </>
          )}
        </div>
        <div className="vv-grid clip-grid-view" grid-size="5"></div>

        <div className="d-flex justify-content-center">
          <Pagination
            showSizeChanger={false}
            className="text-center mt-3"
            current={activePage}
            pageSize={limit}
            onChange={handlePageChange}
            hideOnSinglePage
            total={totalLength}
          />
        </div>
      </div>
    </>
  );
};

export default MediaContent;
